import { render } from "./Updated.vue?vue&type=template&id=61dbd88e"
import script from "./Updated.vue?vue&type=script&lang=js"
export * from "./Updated.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__